export const authSelector = (state) => state.auth;
export const navConfigSelector = (state) => state.navConfig;
export const getApplicationStatusSelector = (state) =>
  state.formProps?.applicationData?.status || "";

export const selectFormData = (state, isDialogForm) =>
  isDialogForm ? state.dialogFormProps?.formData : state.formProps?.formData;

export const selectDgSavedIds = (state, isDialogForm) =>
  (isDialogForm
    ? state.dialogFormProps?.dgSavedIds
    : state.formProps?.dgSavedIds) || [];

export const selectFormConfig = (state, isDialogForm) =>
  isDialogForm
    ? state.dialogFormProps?.formConfig
    : state.formProps?.formConfig;

export const selectFormAppData = (state, isDialogForm) =>
  isDialogForm
    ? state.dialogFormProps?.applicationData
    : state.formProps?.applicationData;

export const selectFormMiscData = (state, isDialogForm) =>
  isDialogForm ? state.dialogFormProps?.misc : state.formProps?.misc;
